import { t } from "@redotech/redo-i18n";
import { Condition } from "@redotech/redo-return-core-common/return-flow/condition";
import { CONDITION_NAMES } from "@redotech/redo-return-core-common/return-flow/condition-names";
import {
  purchaseChannelConditionFromModel,
  validatePurchaseChannelCondition,
  type PurchaseChannelState,
} from "@redotech/redo-return-core-common/return-flow/condition-validate";
import { PurchaseChannel } from "@redotech/redo-return-warranties-common/warranties";
import * as React from "react";
import { ConditionType, ConditionTypeDetailsProps } from "../condition";

export const PURCHASE_CHANNEL = (
  Details: React.ComponentType<ConditionTypeDetailsProps<PurchaseChannelState>>,
): ConditionType<PurchaseChannelState, Condition.PurchaseChannel> => ({
  name: CONDITION_NAMES[Condition.PURCHASE_CHANNEL],
  description(state) {
    return state.channel === PurchaseChannel.RETAIL
      ? t("Purchase Channel: Retail")
      : t("Purchase Channel: {{channel}}", { channel: "Shopify" });
  },
  Details(props: ConditionTypeDetailsProps<PurchaseChannelState>) {
    return React.createElement(Details, props);
  },
  empty: { channel: PurchaseChannel.ONLINE },
  fromModel(model) {
    return purchaseChannelConditionFromModel(model);
  },
  toModel(state) {
    return {
      type: Condition.PURCHASE_CHANNEL,
      channel: state.channel as PurchaseChannel,
    };
  },
  valid(state) {
    return validatePurchaseChannelCondition(state).valid;
  },
});
